/**
 * tRPC Provider - Wrap ứng dụng với QueryClientProvider
 *
 * Với tRPC v11 + @trpc/tanstack-react-query (SPA singleton pattern),
 * không cần tRPC Provider riêng. Chỉ cần QueryClientProvider.
 * Ref: https://trpc.io/docs/client/tanstack-react-query/setup#3c-set-up-without-react-context
 *
 * tRPC client và queryClient được tạo dưới dạng singleton trong trpc.ts
 *
 * Sử dụng trong main.tsx:
 *   <TrpcProvider>
 *     <App />
 *   </TrpcProvider>
 */

import React, { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient, trpcClient, trpc } from './trpc';
import { useAuthStore } from '@/stores/auth.store';
import { toast } from 'sonner';

/**
 * Global Realtime Sync listener
 * Lắng nghe sự kiện từ WebSocket và tự động invalidate cache 
 * để đồng bộ UI theo thời gian thực (tránh dữ liệu bị stale)
 */


export function TrpcProvider({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* DevTools chỉ hiện ở development */}
      {import.meta.env.DEV && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
      )}
    </QueryClientProvider>
  );
}
